import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import { combineReducers } from "redux";
import AuthReducer from "./reducers/AuthReducer";
import StoryReducer from "./reducers/StoryReducer";
import UserReducer from "./reducers/UserReducer";
import FeedBackReducer from "./reducers/FeedBackReducer";
import InterestReducer from "./reducers/InterestReducer";
import SubscriptionReducer from "./reducers/SubscriptionReducer";
import ImageReducer from "./reducers/ImageReducer";
import LessonReducer from "./reducers/LessonReducer";
import Lessonv2Reducer from "./reducers/Lessonv2Reducer";
import ContactReducer from "./reducers/ContactReducer";
import TestimonialReducer from "./reducers/testimonialReducer";

const reducers = combineReducers({
  Auth: AuthReducer,
  Story: StoryReducer,
  User: UserReducer,
  FeedBack: FeedBackReducer,
  Interest: InterestReducer,
  Subscription: SubscriptionReducer,
  Image: ImageReducer,
  LessonPlan: LessonReducer,
  LessonPlanV2: Lessonv2Reducer,
  Contact: ContactReducer,
  Testimonial: TestimonialReducer,
});

export const store = createStore(reducers, {}, applyMiddleware(thunk));

export type RootState = ReturnType<typeof reducers>;
